export function condition() {
    return {
        "data": [
            {
              "flexible_report_condition_id": 1,
              "flexible_report_condition_name": "Sama dengan",
              "flexible_report_condition_icon": "=",
              "flexible_report_condition_status": 1
            },
            {
              "flexible_report_condition_id": 2,
              "flexible_report_condition_name": "Tidak Sama dengan",
              "flexible_report_condition_icon": "!=",
              "flexible_report_condition_status": 1
            },
            {
              "flexible_report_condition_id": 3,
              "flexible_report_condition_name": "Kurang dari ",
              "flexible_report_condition_icon": "<",
              "flexible_report_condition_status": 1
            },
            {
              "flexible_report_condition_id": 4,
              "flexible_report_condition_name": "Kurang dari Sama dengan ",
              "flexible_report_condition_icon": "<=",
              "flexible_report_condition_status": 1
            },
            {
              "flexible_report_condition_id": 5,
              "flexible_report_condition_name": "Lebih dari",
              "flexible_report_condition_icon": ">",
              "flexible_report_condition_status": 1
            },
            {
              "flexible_report_condition_id": 6,
              "flexible_report_condition_name": "Lebih dari sama dengan",
              "flexible_report_condition_icon": ">=",
              "flexible_report_condition_status": 1
            },
            {
              "flexible_report_condition_id": 7,
              "flexible_report_condition_name": "Mengandung",
              "flexible_report_condition_icon": "ILIKE",
              "flexible_report_condition_status": 1
            },
            {
              "flexible_report_condition_id": 8,
              "flexible_report_condition_name": "Tidak mengandung",
              "flexible_report_condition_icon": "NOT ILIKE",
              "flexible_report_condition_status": 1
            },
            {
              "flexible_report_condition_id": 9,
              "flexible_report_condition_name": "Antara",
              "flexible_report_condition_icon": "BETWEEN",
              "flexible_report_condition_status": 1
            }
          ]
    }
};